/* Cart drawer (Mark & Sarah look): change a line's colour or size in place. */
class HlCartVariant extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('script[type="application/json"]');
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.querySelectorAll('select').forEach((select) => select.addEventListener('change', () => this.onChange()));
  }

  async onChange() {
    const picked = [...this.querySelectorAll('select')].map((select) => select.value);
    const match = this.variants.find((v) => v.o.every((value, i) => value === picked[i]));
    if (!match || !match.a) return this.fail('This option is sold out.');
    if (String(match.id) === this.dataset.variantId) return;

    const row = this.closest('.cart-item');
    row?.classList.add('hl-is-updating');
    try {
      const cart = await (await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();
      const already = cart.items.filter((i) => i.variant_id === match.id).reduce((n, i) => n + i.quantity, 0);
      const quantity = Number(this.dataset.quantity) || 1;
      const response = await fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: { [this.dataset.lineKey]: 0, [match.id]: already + quantity },
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not update your cart.');
      document.querySelector('cart-drawer')?.renderContents({ id: null, sections: state.sections });
    } catch (error) {
      row?.classList.remove('hl-is-updating');
      this.fail(error.message);
    }
  }

  fail(message) {
    const box = this.querySelector('[data-hl-variant-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
    }
    this.querySelectorAll('select').forEach((select) => {
      select.value = select.dataset.current;
    });
  }
}

if (!customElements.get('hl-cart-variant')) customElements.define('hl-cart-variant', HlCartVariant);
